const config = {
    build_number: '616114',
    build_timestamp: '2026-09-16T17:31:15.883Z',
    build_commit: '69441492e481d114b2d8650146be4f72b1348337',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
